import {Enum} from "../../utils/enum.utils";

export const BackofficeRoles = Enum({
    ACCESS: {label: "Accès au backoffice"}
});
